import commodityRestService from '../services/commodity/CommodityRestService'
import CommodityDto from '../models/Commodity'

const state = {
  commodities: [],
  filteredCommodities: [],
  dialogActived: false,
  selectedItems: [],
  defaultItem: CommodityDto
}

const getters = {
  getCommodities: state => state.commodities,
  isDialogActived: state => state.dialogActived,
  getSelectedItems: state => state.selectedItems,
  getDefaultItem: state => state.defaultItem,
  getFilteredCommodities: state => state.filteredCommodities
}

const actions = {
  async getCommodities (context, filter) {
    filter.page = filter.page - 1
    if (!filter.processId) {
      filter.processId = -1
    }
    try {
      let data = await commodityRestService.getCommodities(filter)
      context.commit('setCommodities', data)
    } catch (error) {
      let snackBarContent = {actived: true, message: 'Error Consultando Mercadería.', color: 'error'}
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
      throw error
    }
  },
  async saveIncome (context, commodityInfo) {
    let snackBarContent = {actived: true, message: 'Mercaderia Agregada Exitosamente.', color: 'success'}
    try {
      await commodityRestService.saveIncome(commodityInfo)
    } catch (error) {
      snackBarContent = {actived: true, message: 'Error Agregando Mercaderia.', color: 'error'}
    }
    context.commit('setSnackBarStatus', snackBarContent, {root: true})
  },
  setDialogActived (context, active) {
    context.commit('setDialogActived', active)
  },
  setSelectedItems (context, selectedItems) {
    context.commit('setSelectedItems', selectedItems)
  },
  async filterItems (context, filters) {
    try {
      let data = await commodityRestService.filterCommodities(filters)
      context.commit('filterCommodity', data)
    } catch (error) {
      console.log('Error Filtering commodities.')
    }
  },
  refreshFilteredCommodities (context) {
    context.commit('refreshFilteredCommodities')
  }
}

const mutations = {
  setCommodities (state, commodities) {
    state.commodities = commodities
  },
  setDialogActived (state, active) {
    state.dialogActived = active
  },
  setSelectedItems (state, selectedItems) {
    state.selectedItems = selectedItems
  },
  filterCommodity (state, data) {
    state.filteredCommodities = data
  },
  setSelectedItemAsDefault (state) {
    state.selectedItems = []
  },
  refreshFilteredCommodities (state) {
    state.filteredCommodities = state.commodities
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
